<template>
  <div class="base_detail_modal">
     
    <Modal    
          v-model="detail_modal"
          title="上门维修" 
            :width="screenWidth*0.7"
          @on-cancel="cancel" @on-visible-change="handleVisibleChange">
          <div class="base-modal" v-if="detail_modal"> 
            <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}">
              <Alert type="warning" show-icon closable>温馨提示:未提交前请勿刷新页面，否则会丢失填入的数据和附件。</Alert>   
            <Form :model="dataDetail" ref="dataDetailForm" :label-width="150" :rules="ruleValidate">
              <Alert>基本信息</Alert>   
              <Row>
                
                <Col span="12">
                
                    <FormItem label="房屋地址"  prop="房屋地址">
                     <Select :disabled="true" filterable :remote-method="findHouse" :loading="houseSelectloading"  v-model="selectedHouseId" @on-select="chooseHouse" placeholder="请选择..." clearable>
                        <Option   v-for="item in selectHouseList" :key="item['房源ID']" :value="item['房屋地址']">{{item['房屋地址']}}</Option> 
                      </Select>
                  </FormItem>
                </Col> 
               <Col span="12">
                <FormItem label="*房屋地址支持搜索"></FormItem>
                </Col>
              </Row>
          
              <Row>
                <Col span="12">
                  <FormItem label="租客姓名"   prop="租客姓名">
                    <Input :disabled="isInput" v-model="dataDetail['租客姓名']" placeholder="暂无" ></Input>
                  </FormItem>
                </Col> 
                <Col span="12">
                  <FormItem label="报修人联系电话"  prop="联系电话">
                    <Input :disabled="isInput" v-model="dataDetail['联系电话']" placeholder="暂无" ></Input>
                  </FormItem>
                </Col> 
               
              </Row> 
           
            <Alert>维修清单(共{{questionList.length}}条)</Alert>   
            <div v-for="(item,questionIndex) in questionList" :key="item['问题描述']" style="margin-top: 20px;">

               <Alert type="success" v-if="questionList.length==1">维修项（{{questionIndex+1}}/{{questionList.length}}） </Alert>  
              <div class="small-title" v-else>
                <Alert type="success">维修项（{{questionIndex+1}}/{{questionList.length}}） </Alert>  
                 <Button type="error" ghost @click="deleteQuestion(questionIndex)" >删除</Button>     
              </div>
          
           
              <Row>
                <Col span="24">
                  <FormItem label="故障描述"   prop="故障描述">
                    <Input :disabled="isInput" v-model="item.gzms" placeholder="暂无" ></Input> 
                  </FormItem>
                </Col>  
              </Row>
            <Row>
                <Col span="12">
                  <FormItem label="维修员"  prop="维修员">
                    <Input :disabled="isInput" v-model="item.repairPerson" placeholder="暂无" clearable></Input>
                  </FormItem>
                </Col> 
                  <Col span="12">
                  <FormItem label="维修员联系电话"  prop="维修员联系电话">
                    <Input :disabled="isInput" v-model="item.repairPersonTel" placeholder="暂无"  clearable></Input>
                  </FormItem>
                </Col> 
               </Row>
                <Row>
                  <Col span="24">
                    <FormItem label="维修状态"  >
                          <RadioGroup v-model="item.state"  @on-change="(val) => changeRadio(val, questionIndex)">
                            <Radio label="待维修">待维修</Radio>
                            <Radio label="已完成">已完成</Radio>
                            <Radio label="无法维修">无法维修</Radio>
                          </RadioGroup>
                    </FormItem>
                  </Col> 
                </Row>
                 <Row>
                  <Col span="24">
                    <FormItem label="维修留言"  >
                      <Input :disabled="isInput" v-model="item.repair_message" placeholder="暂无" style="width: 100%;"  clearable></Input>
                    </FormItem>
                  </Col> 
                 </Row>

               <!-- 附件-问题 -->
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_wechat(response, file, fileList, null,null,questionIndex,'上门维修_子项目_问题图片')" 
                    :show-upload-list="true" 
                    max-size="100*1024" 
                    :disabled="isInput">
                    <Button type="info" style="margin-left:20px;" :disabled="isInput">问题相关图片</Button>
                  </Upload>

                  <Table border :columns="fjColums" :data="item.fj" :max-height="400"  :key="'fj-table-' + questionIndex" > 
                  <template #img="{ row, index } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png','webg'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="row.img" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, index } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'shfjList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'shfjList')">下载</div> 
                           <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(questionIndex,index,'fj',row)" v-if="!isInput">删除</div>
                      </div>
                    </template> 
                  </Table>
               <!-- 附件-维修 -->
                  <Upload :action="uploadUrl"  
                    :headers="{ 'Authorization': 'Bearer ' +token }"
                    accept=".jpg,.jpeg,.png,.pdf"
                    :on-success="(response, file, fileList) => uploadSuccess_wechat(response, file, fileList, null,null,questionIndex,'上门维修_子项目_维修图片')" 
                    :show-upload-list="true" 
                    max-size="100*1024" 
                    :disabled="isInput">
                    <Button type="info" style="margin-left:20px;margin-top: 20px;" :disabled="isInput">维修后相关附件</Button>
                  </Upload>

                  <Table border :columns="fjColums" :data="item.repair_fj" :max-height="400"  :key="'repair-fj-table-' + questionIndex"  > 
                  <template #img="{ row, index } " >
                      <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png','webg'].includes(row.suffix)">
                        
                        <img style="width:200px;height:200px;" :src="row.img" alt="">
                      </div>
                      <div v-else>仅支持图片预览</div>
                    </template> 
                    <template #action="{ row, index } " >
                      <div class="buttomGroup">
                        <div class="btn ck" @click="watchFile(row,'shfjList')">查看</div>
                        <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'shfjList')">下载</div> 
                         <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(questionIndex,index,'repair_fj',row)" v-if="!isInput">删除</div>
                      </div>
                    </template> 
                  </Table>
               </div>


          


              </Form>
          </VuePerfectScrollbar>

          
          </div>
          <template #footer>
                 <div style="display: flex;justify-content: flex-end;gap:20px;">
                <Button type="success" @click="  addNewQuestion()" v-if="!isInput">添加新维修子项</Button> 
                 <Button type="default" @click="cancelModal">关闭</Button>
                <Button type="primary" @click="handleSubmit('dataDetailForm')" v-if="!isInput">提交</Button>  
                </div>
            </template>

    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'; 
import {utilTools} from "@/utils/js/utilTools.js"
import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
import {smwxMethod_9_001} from "@/api/9小程序管理/9_001_smwx"; 
import {cbglMethod} from "@/api/8成本管理/cbgl";
import {userMethod} from "@/api/login/user.js"
export default {
  name:"detail_modal",
  comments:{VuePerfectScrollbar},
  props:{
    dataDetail:{
      type:Object,
      default:{
        "房屋地址":"",//房屋地址
                "房源ID":"",//房源ID 
                "故障类型":"",//故障类型
                "故障区域":"",//故障区域
                "上门日期":"",//上门日期
                "上门时间":"",//上门时间
                "故障描述":"",//故障描述
                "联系电话":"",//联系电话
                "附件信息":[],//附件信息 
                "租客姓名":"",//联系电话
                "联系电话":"",//联系电话
                childList:[],
      },
    },
    isInput:{
      type:Boolean,
      default:false
    }
    
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          //上传文件s
          uploadUrl:"/xjby/api/file/uploadHouseFiles",
          fjColums:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          
          detail_modal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant"],
          skjeValidate :(rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入收款金额'));
                }
                if (value <= 0 ) {
                            callback(new Error('请核实您输入的金额'));
                        } 
              
              },
          ruleValidate:{
            skje: [
                        {  validator: this.skjeValidate,   trigger: 'blur' }
                    ],
                     
                  // qqh: [
                  //       { required: true, message: '丘权号不能为空', trigger: 'blur' }
                  // ],
                  },
          dataDetailShow:{},
          xzqList:[
            {label:"白下区",value:""}, {label:"鼓楼区",value:""}, {label:"建邺区",value:""},
            {label:"江宁区",value:""}, {label:"老下关",value:""}, {label:"浦口区",value:""},
            {label:"栖霞区",value:""}, {label:"秦淮区",value:""}, {label:"宣武区",value:""},
            {label:"雨花台区",value:""}, 
          ],
          // 筛选房源的select相关参数
          selectHouseList:[],//房屋地址筛选
          houseSelectloading:false,//房屋地址筛选-select加载
           selectedHouseId: null, // 用来存当前用户选中的房源ID
          repairEmployeeList:[],//维修工信息,CONCAT('(', "工种", ')', username) AS formatted_username,username,accountno,"工种"
        
          ryList:[],//根据工时单-工种更新人员名单
          // 损坏附件情况
          shfjList:[],
          // 领料单相关
          lldSpflList:[],//领料单商品分类
          lldSpmcList:[],//领料单商品名称
          lld:{
            spfl:"",spmc:"",spsl:0, 
          },
          // lldTableData:[],
          lldTableColumns:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '商品分类', key: 'productCategory', align: 'center'}, 
            {title: '商品代码', key: 'productCode', align: 'center'}, 
            {title: '商品名称', key: 'productName', align: 'center'}, 
            {title: '商品数量', key: 'productQuantity', align: 'center'}, 
            {title: '计量单位', key: 'unit', align: 'center'}, 
            {title: '规格型号', key: 'specification', align: 'center'}, 
            {title: '领料仓库', key: 'warehouse', align: 'center'}, 
            {title: '操作', slot: 'action', width:140, align: 'center'}
          ],
          // 工时单相关
          gsd:{
            gzlx:"装修工时",gz:"",rymc:"",gs:0
          },
          gsdTableColumns:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '房屋地址', key: 'fwdz', align: 'center'}, 
            {title: '工作类型', key: 'gzlx', align: 'center'}, 
            {title: '工种', key: 'gz', align: 'center'}, 
            {title: '人员名称', key: 'rymc', align: 'center'}, 
            {title: '工时', key: 'gs', align: 'center'},  
            {title: '操作', slot: 'action', width:140, align: 'center'}
          ],
          ruleValidate:{
                  "房屋地址": [
                        { required: true, message: '房屋地址不能为空', trigger: 'blur' }
                    ],
                  //   "故障类型": [
                  //       { required: true, message: '故障类型不能为空', trigger: 'blur' }
                  // ],
                  // "故障区域": [
                  //       { required: true, message: '故障区域不能为空', trigger: 'blur' }
                  // ],
                  // "租客姓名": [
                  //       { required: true, message: '租客姓名不能为空', trigger: 'blur' }
                  // ],
                  // "联系电话": [
                  //       { required: true, message: '租客手机号码不能为空', trigger: 'blur' }
                  // ],
                  },
          questionList:[//问题列表
                   {
                    id:"",
                    gzms:"",//问题描述（必填）
                    repairPerson:"",//维修人
                    repairPersonTel:"",//维修人联系方式
                    fj:[],//问题图片列表 
                    state:"待维修",//状态：待维修，已完成，无法维修。默认待维修
                    repair_message:"",//维修留言
                    repair_fj:[],//维修后图片
                  }
          ],
          tempList:[], 
          // gsdTableData:[],
           
        }

    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
   
    },
    created(){  
      console.log("dataDetail===",this.dataDetail)

      console.log("u",this.$store.state.userInfo); 
    },
   
    watch:{
      
    },
    methods:{
      changeSmrq(date){
        console.log("1112223233")
        console.log("date==",date)
        this.dataDetail['上门日期']=date
        console.log("this.dataDetail==",this.dataDetail)
      },
      // 弹窗显示/隐藏事件
      handleVisibleChange(visible){
        // console.log("visible==",visible)
        // if(visible){
        //   this.initRepairEmployee()
        //   this.initlldSpflList() 
        //   this.cleanPhotoList()
        // }
        // this.cleanPhotoListV3("损坏附件","1_上门维修",this.dataDetail.id,"损坏附件",null,null)
       
      },
      // 清晰数据
      cleanData(){
         this.selectedHouseId=this.dataDetail['房屋地址'] 
        this.dataDetail['联系电话']=this.dataDetail['报修人联系电话']
        this.initQuestionList( this.dataDetail.id)

      },
      // 加载问题列表
      // initQuestionList(fatherId){
      //   smwxMethod_9_001.selectQuestionList({id:fatherId}).then((res)=>{
      //     // this.questionList=res.data.list
      //     this.makeFjAndRepairFjReactive()

      //   })
      // },
      // 设置响应式变量
       makeFjAndRepairFjReactive() {
    this.questionList.forEach((item, index) => {
      // 处理 fj
      if (!item.hasOwnProperty('fj')) {
        this.$set(this.questionList, index, {
          ...item,
          fj: []
        });
      } else if (!Array.isArray(item.fj)) {
        this.$set(this.questionList[index], 'fj', []);
      } 
      // 确保 fj 是数组（即便不是响应式，也强制设为空数组，可选）
      // 通常来说，只要不是 undefined/null，.push 是不会报错的，但为了严谨你可以判断

      // 处理 repair_fj
      if (!item.hasOwnProperty('repair_fj')) {
        this.$set(this.questionList, index, {
          ...item,
          repair_fj: []
        });
      } else if (!Array.isArray(item.repair_fj)) {
        this.$set(this.questionList[index], 'repair_fj', []);
      }
    });
  },
      // 加载子问题列表
      async initQuestionList() {
        console.log("子集this.dataDetail==", this.dataDetail);
        let questionList = this.dataDetail.childList;

        const filePromises = questionList.map(async (i) => {
          i.gzms = i.question_discribe;
          i.repairPerson = i.repair_worker;
          i.repairPersonTel = i.rapair_worker_tel;

          // 获取文件信息（可能是异步返回的普通数组）
          const fjList = await this.getFileInfo("1_上门维修_简易", i.id, "上门维修_子项目_问题图片", null);
          const repairFjList = await this.getFileInfo("1_上门维修_简易", i.id, "上门维修_子项目_维修图片", null);

          i.fj = fjList; // 可能是普通数组
          i.repair_fj = repairFjList; // 可能是普通数组

          return i;
        });

      try {
        const updatedQuestionList = await Promise.all(filePromises);

        // ✅ 关键步骤：遍历 updatedQuestionList，确保 fj 和 repair_fj 是响应式数组
        const reactiveQuestionList = updatedQuestionList.map((item, index) => {
          const reactiveItem = { ...item }; // 浅拷贝，避免直接修改原对象

          // 确保 fj 是响应式数组
          if (!Array.isArray(reactiveItem.fj)) {
            reactiveItem.fj = []; // 默认空数组
          }
          this.$set(reactiveItem, 'fj', reactiveItem.fj);

          // 确保 repair_fj 是响应式数组
          if (!Array.isArray(reactiveItem.repair_fj)) {
            reactiveItem.repair_fj = []; // 默认空数组
          }
          this.$set(reactiveItem, 'repair_fj', reactiveItem.repair_fj);

          return reactiveItem;
        });

        // ✅ 将处理后的响应式列表赋值给 this.questionList
        this.questionList = reactiveQuestionList;

      } catch (error) {
        console.error("获取文件信息失败:", error);

        // 如果出错，依然给原始 questionList 的每一项设置默认的响应式数组
        const safeQuestionList = questionList.map((i) => {
          const safeItem = { ...i };
          this.$set(safeItem, 'fj', []);
          this.$set(safeItem, 'repair_fj', []);
          return safeItem;
        });

        this.questionList = safeQuestionList;
      }
    },

         // 获取附件信息
  async  getFileInfo(father_table,father_id,type_1,type_2){
        let params={
          father_table:father_table,
          father_id:father_id,
          type_1:type_1,
          type_2:type_2
        }

        return smwxMethod_9_001.selectFilesForWechat(params).then((res)=>{
          res.data.selectRes.forEach((i)=>{
            i.img=window.applicationConfig. fileBaseUrl +i.save_name
          })
          console.log("图片",res.data.selectRes)
          return res.data.selectRes
        })
        
    },
              // 删除单个问题（>=2时）（前后端都删除切不可恢复！！！）
        deleteQuestion(index){  
          console.log("delete按钮")
        let questionList=this.questionList
        let item = questionList[index]
        if(questionList.length<=1){
            this.$Message.warning({
              content:"至少要保留一个问题",
              duration:1,
            });
        
          return;
        } 
          let _this=this
           this.$Modal.confirm({
              title: '确认删除提醒',
              content: `<br>是否删除删除当前问题[${index+1}]？删除后不可恢复。<br>`,
              onOk(){
                smwxMethod_9_001.deleteDetailRecord({id:_this.questionList[index].id}).then((res)=>{
                  if(res.data.deleteRes>0){
                    questionList = questionList.filter((_, i) => i !== index)
                   _this.questionList=questionList
                   _this.$Message.success("删除记录成功")
                  }else{
                    _this.$Message.error("删除错误，请联系管理员！")
                  }
                })
                 

              }})
    
      },
      // 新版清洗照片（新旧系统一起获取）（非房源版本）

      cleanPhotoListV3(key,father_table,father_id,type_1,type_2,old_data){
        let data= []
        //  新系统
        fileMethod.selectFiles({father_table:father_table,father_id:father_id,type_1:type_1,type_2:type_2}).then((res)=>{
          console.log(key,"--查询结果--",res)
         if(res.data.selectRes){
          res.data.selectRes.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img: window.applicationConfig.fileBaseUrl + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
         } 
         console.log("查询后组装--",data)
         this.saveImage(key,data)
        })
      },
   
     
      // 提交
      handleSubmit(name) { 
          let _this=this
  //  hire_person_tel
         let dataDetail = _this.dataDetail
         dataDetail.lxdh=dataDetail["联系电话"]
         dataDetail.zkxm=dataDetail["租客姓名"]
          _this.questionList.forEach((i)=>{ 
            i.question_discribe=i.gzms,
            i.repair_worker=i.repairPerson,
            i.rapair_worker_tel=i.repairPersonTel,
            i.house_add=dataDetail["房屋地址"],
            i.hire_name=dataDetail.zkxm,
            i.hire_tel=dataDetail.lxdh,
            i.house_id=dataDetail.fyid
        })
        dataDetail.questionList=_this.questionList
        console.log("🔍 提交时打印整个 dataDetail 对象：", this.dataDetail);
        console.log("📞 联系电话的值是：", this.dataDetail['联系电话']);
        console.log("提交前检查this.$refs[name]===",this.$refs[name])
       this.$refs[name].validate((valid) => {
       console.log("valid===",valid)
         if (valid) {
            // this.$Message.success('Success!'); 
          
            this.$Modal.confirm({
              title: '确认提交保存提醒',
              content: `<br>请核实您输入的信息<br>`,
              onOk(){
                 
             
                  smwxMethod_9_001.updateRepairRecordV2(dataDetail).then((res)=>{
                   let newId = res.data.newId
                   if(Object.values(res.data).every(value => value > 0)){
                    _this.$Message.success("修改成功！")
                    _this.detail_modal=false      
                    _this.$emit("init")
                    }else{
                      _this.$Message.error("修改失败！请联系管理人员。")
                    }
                  })  
              } 
            })
         } else {
             this.$Message.error('请核实输入的内容!');
         }
        })
      },
      // select用于查询房源
      findHouse(query){
       
        if (query !== '') {
                    this.houseSelectloading = true;
                    setTimeout(() => {
                        this.houseSelectloading = false;
                         let params={
                          houseName:query 
                         }
                         smwxMethod_9_001.getHouseListByName(params).then((res)=>{
                          console.log("res==",res)
                          this.selectHouseList=res.data.list
                         })
                          
                    }, 200);
                } else {
                    this.selectHouseList = [];
                }
      },
      // select用于选择item时传输房源id
    // 选中某个房屋地址后触发
    chooseHouse(selectedHouseId) {
      console.log("选中的房源地址是：", selectedHouseId);
      console.log("this.selectHouseList==",this.selectHouseList)
        // 找到对应的 item 对象
        const selectedItem = this.selectHouseList.find(
          (item) => item["房屋地址"] === selectedHouseId
        );

        if (selectedItem) {
          console.log("选中的完整对象是：", selectedItem);

        
          this.dataDetail['房源ID']=selectedItem['房源ID']
           this.dataDetail['房屋地址']=selectedItem['房屋地址']
          console.log("dataDetail==",this.dataDetail)
          // 或者：如果你能直接修改 props（不推荐），但通常你应该用 emit 通知父组件更新
          // 注意：props 是只读的，你应该通过 emit 通知父组件去改
        } else {
          console.warn("未找到选中的房源对象，ID=", selectedHouseId);
        }
      },
      // radio点击事件
      changeRadio(val,index){
        console.log("radio点击事件.val===",val) 
        this.questionList[index].state=val
        console.log("this.questionList[index]===",this.questionList[index])
      },
      // 旧系统照片下载并暂存到新系统中
      downloadAndSaveImage(){
        
      },
        // 添加新问题
      addNewQuestion(){ 
        let questionList=this.questionList
        
        console.log("questionList===",questionList)
        let msg=""
        if(questionList.length>=10){
        msg="一个房源一次最多添加10条问题！"
          this.$Message.info({
            content:msg,
            duration:1,
         });
        }else{
          
          smwxMethod_9_001.addNewEmptyQuestion({fatherId:this.dataDetail.id}).then((res)=>{
            if(res.data.newId>0){
               let newQuestion= {
                id:res.data.newId,
                father_id:this.dataDetail.id,
                gzms:"",//问题描述（必填）
                repairPerson:"",//维修人 
                repairPersonTel:"",//维修人联系方式 

                fj:[],//问题图片列表
                state:"待维修",//状态：待维修，已完成，无法维修。默认待维修
                repair_message:"",//维修留言
                repair_fj:[],//维修后图片
              }
              questionList.push(newQuestion)
              this.questionList=questionList
              msg="添加成功！"
              this.$Message.info({
                content:msg,
                duration:1,
              });

            }
          })
         
        }
       
      
        
      },
      // 存放照片
      saveImage(key,data){
          
          if(key==="客厅照片"){ this.ktImgList=data }
          else if(key==="卧室照片"){ this.wsImgList=data }
          else if(key==="厨房照片"){ this.cfImgList=data }
          else if(key==="卫生间照片"){ this.wsjImgList=data }
          else if(key==="其他照片"){ this.qtImgList=data }

          else if(key==="房屋托管合同信息"){ this.fwtghtImgList=data }
          else if(key==="产证信息"){ this.czImgList=data }
          else if(key==="身份证信息"){ this.sfzImgList=data }
          else if(key==="授权委托书"){ this.sqhtsImgList=data } 
          else if(key==="损坏情况"){ this.shfjList=data } 
          else if(key==="损坏附件"){ this.dataDetail['附件信息']=data } 
          

        },
      // 房屋文件上传
      async uploadSuccess_dataDetail(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

       

         
          // let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" + obj.show_url, localStorage.getItem('token'));
          // obj.img_base64 = img_base64;
           let obj = {
            save_name: response.data.saveName,
          save_url: response.data.savePath,
          show_name: response.data.showName,
          show_url: response.data.showPath,
          suffix: response.data.suffix,
          img: window.applicationConfig.fileBaseUrl +response.data.showPath,
          type_1:"租客上传",
          type_2:imageType?imageType:null,
          bz:"new_system", 
          needInsert:true
        };
          console.log("dataDetail==", this.dataDetail);
       
          this.dataDetail['附件信息'].push(obj);
          console.log("this.dataDetail['附件信息']==",this.dataDetail['附件信息'])

       
      },
         // 房屋文件上传
      async uploadSuccess_wechat(response, file, fileList, name,imageType,itemIndex,type_1_name) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name); 
        console.log("itemIndex===", itemIndex); 
         
          // let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" + obj.show_url, localStorage.getItem('token'));
          // obj.img_base64 = img_base64;
        let obj = {
          save_name: response.data.saveName,
          save_url: response.data.savePath,
          show_name: response.data.showName,
          show_url: response.data.showPath,
          suffix: response.data.suffix,
          img: window.applicationConfig.fileBaseUrl +response.data.showPath,
          father_id:this.questionList[itemIndex].id,
          father_table:"1_上门维修_简易",
          type_1:type_1_name,
          type_2:imageType?imageType:null,
          bz:"new_system", 
          needInsert:true
        };
        smwxMethod_9_001.insertWechatFileRecord(obj).then((res_2)=>{
          console.log("上传结果====res_===",res_2)
           if(res_2.success){
              obj.id=res_2.data.insertId
            if(type_1_name=="上门维修_子项目_问题图片"){
            
              this.questionList[itemIndex].fj.push(obj);
            }else{
            
                this.questionList[itemIndex].repair_fj.push(obj);
            } 
            console.log("上传成功，当前附件列表：", 
              type_1_name == "上门维修_子项目_问题图片" 
                ? this.questionList[itemIndex].fj 
                : this.questionList[itemIndex].repair_fj
            );
            this.$forceUpdate(); 

           }
        })

       
      },
    
       // 在线预览文件
       watchFile(row,name) { 
        console.log("row==",row)
        let url="";
          // console.log("row.show_path==",row.show_path)
            // console.log("if1=",row.show_path==null)
        if(row.show_path==null||row.show_path==""){
          url=row.img
        }else{
          url="/xjby/view/" + row.show_path
        }
        utilTools.downloadFromUrl(url, row.show_name, "open",localStorage.getItem('token'))
      },
      // 下载附件
        downloadFile(row,name) {
            console.log("row==",row)
        let url="";
        if(row.show_path==null||row.show_path==""){
          url=row.img
        }else{
          url="/xjby/view/" + row.show_path
        }
          utilTools.downloadFromUrl(url, row.show_name, "download",localStorage.getItem('token'))
      },
      // 删除预上传的附件 (问题question的index，图片的imageIndex，图片类型【fj/repair_fj】，当前行)
      deleteFileBefore(index,imageIndex,imageType,row) {
        let _this=this
        this.$Modal.confirm({
        title: '确认删除提醒',
        content: `<br> 删除后不可恢复<br>`,
        onOk(){
          // _this.questionList[index].fj.splice(imageIndex, 1);
          // repair_fj
          // qIndex=index
          // index=imageIndex
          console.log("row===",row)
          let pgIndex= row.id//数据库id
          console.log("pgIndex==",pgIndex)  
        
          smwxMethod_9_001.deleteWechatFile({id:pgIndex}).then((res)=>{
             if(res.data.deleteRes>0){
              console.log("[index]===",index)
               console.log("[imageIndex]===",imageIndex)
                console.log("_this.questionList[index]===",_this.questionList[index])
                console.log("_this.questionList[index]===",_this.questionList[index])
                console.log("_this.questionList[index][imageType]===",_this.questionList[index][imageType])
                
               _this.questionList[index][imageType].splice(imageIndex, 1);
                _this.$Message.success("删除成功")
          //    ['questionList['+qIndex+'].'+property]:  this.data.questionList[qIndex].fj
             
            }else{
              this.$Message.error("删除失败，请联系管理员")
             }
          })
           
          
        
           //小程序代码
           // 小程序版代码参考
          // API.getDataV2('/api/file/deleteWechatFile', "POST", {id:pgIndex}).then(res =>{
          //   console.log("res===",res) 
          //   if(res.data.deleteRes>0){
          //     // this.data.questionList[qIndex][property].splice(index, 1);
          //     this.setData({
          //       ['questionList['+qIndex+'].'+property]:  this.data.questionList[qIndex].fj
          //     });
          //     wx.showToast({
          //       title: '删除图片成功！',
          //       icon:"none",
          //       duration:1500
          //     })   
          //   }else{
          //     wx.showToast({
          //       title: '删除失败，请联系管理员',
          //       icon:"none",
          //       duration:2500
          //     }) 
          //   }
          
              
          // }) 



        }
      })
      },
    

      // 前台删除 
      deleteLRecord(index){
        this.dataDetail['附件信息'].splice(index, 1);
      },
       // 前台删除工时单
       deleteGsd(index){
        this.gsdTableData.splice(index, 1);
      },
      // 损坏附件上传
        async uploadSuccess_house(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

        let obj = {
          save_name: response.data.saveName,
          save_url: response.data.savePath,
          show_name: response.data.showName,
          show_url: response.data.showPath,
          suffix: response.data.suffix,
          type_1:"租客上传",
          type_2:imageType?imageType:null,
          bz:"new_system",  
        };

        try {
          let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" + obj.show_url, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          console.log("obj==", obj);
          this.dataDetail['附件信息'].push(obj)

          // if (name === "czImgList") {
          //   this.czImgList.push(obj);
          // }
          // else if(name === "sfzImgList") {
          //   this.sfzImgList.push(obj);
          // }
          // else if(name === "fwtghtImgList") {
          //   this.fwtghtImgList.push(obj);
          // }
          // else if(name === "fwImgList") {
          //   this.fwImgList.push(obj);
          // }
          // else if(name === "sqhtsImgList") {
          //   this.sqhtsImgList.push(obj);
          // }
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
        // 清洗照片
        cleanPhotoList(key){ 
          if(this.dataDetail.source==="new_system"){
            let data = this.dataDetail[key];
            zfglMethod_2_001.getHousePhotosById({id:this.dataDetail.id,type_1:key,}).then((res)=>{
              console.log(key,"--查询结果--",res)
              let data = res.data
              this.getPhotoList_newSystem(key,data)
            }) 
          }else{
            if (!this.dataDetail[key]) {
              this.saveImage(key,[])
            }
            
            let data = JSON.parse(this.dataDetail[key]);
            if (data.length === 0) {
              this.saveImage(key,[])
            }
            return  this.getPhotoList_oldSystem(key,data)
          } 
         },
         //旧系统获取图片
        getPhotoList_oldSystem(key,data){
          let imgList = [];
          
          for (const obj of data) {
            if (obj.bz === "new_system") {
              let tempObj={
                    show_name:obj.show_name,
                    type_2:obj.type_2,
                    img:"http://localhost:8080/xjby/view/" + obj.show_path,
                    
                  }
                  imgList.push(tempObj);
              
              // imgList.push("http://localhost:8080/xjby/view/"+obj.show_url);
            } else {
              let tempObj={
                    show_name:obj.show_name,
                    type_2:obj.type_2,
                    img:"http://localhost:8080/xjby/view/" + obj.fileAddress
                  }
                  imgList.push(tempObj);
              // imgList.push(this.imgBaseUrl + obj.fileAddress);
            }
          }
          console.log("imgList==",imgList) 
          this.saveImage(key,imgList)
        },
//新系统获取图片
        getPhotoList_newSystem(key,data){
          let imgList = [];
          zfglMethod_2_001.getHousePhotosById({id:this.dataDetail.id,type_1:key}).then((res)=>{
           if(res.data!=null&&res.data.list.length>0){
            res.data.list.forEach((i)=>{
              let obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    id:i.id
                  }
                  imgList.push(obj);
              // imgList.push("http://localhost:8080/xjby/view/"+i.show_path);
            })
           }
           this.saveImage(key,imgList)
          })
          
        }, 
          // 存放照片
      saveImage(key,data){
       this.shfjList=data
      },
      
      changeGz(name){
        console.log("repairEmployeeList==",this.repairEmployeeList)
        this.ryList= this.repairEmployeeList.filter(employee => employee['工种'] === name);
      },
   
      cancel(){
        this.modal=false
      },
     
      changeHtdqr(date){
        this.dataDetail.htdqr=date
      },
      changeJfrq(date){
        this.dataDetail.jfrq=date
      },
      // 关闭弹窗
      cancelModal(){
        // let   questionList=[//问题列表
        //            {
        //             id:"",
        //             gzms:"",//问题描述（必填）
        //             repairPerson:"",//维修人
        //             repairPersonTel:"",//维修人联系方式
        //             fj:[],//问题图片列表 
        //           }
        //   ]
        //   let dataDetail={
        //      "房屋地址":"",//房屋地址
        //         "房源ID":"",//房源ID 
        //         "故障类型":"",//故障类型
        //         "故障区域":"",//故障区域
        //         "上门日期":"",//上门日期
        //         "上门时间":"",//上门时间
        //         "故障描述":"",//故障描述
        //         "联系电话":"",//联系电话
        //         "附件信息":[],//附件信息 
        //         "租客姓名":"",//联系电话
        //         "联系电话":"",//联系电话
        //   }
        //   this.questionList=questionList
        //   this.dataDetail=dataDetail
        this.$emit("closeModal")
          this.detail_modal=false

      }
     
    }


}
</script>

  
  <style lang="scss" >
 

.base-modal{
        width: 100%;
        height: 660px;
        padding: 20px;
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }

        }
        .small-title{width: 100%;

          display: grid;
          grid-template-columns: 92% 5%;
          column-gap: 3%;
        }
        .buttomGroup{
                display: flex;
                width: 100%;
                text-align: center;
                align-items: center;
                justify-content: center;
                gap:20px;
                .btn{
                  width: 56px;
                  height: 34px;
                  border-radius: 4px;
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  line-height: 34px;
                  text-align: center;
                  cursor: pointer;
                }
                .ck{
                  background:rgba($color: #307EFF, $alpha: 0.1);
                  color: #307EFF;
                }
                .tg{
                  background:rgba($color: #0FD738, $alpha: 0.1);
                  color: #01B054 ;
                }
                .th{
                  background:rgba($color: #FF890A, $alpha: 0.1);
                  color: #FF890A;
                }
                .bj{
                  background:rgba($color: #307EFF, $alpha: 0.1);
                  color: #307EFF;
                }
                .tj{
                  background:rgba($color: #1CB9FF, $alpha: 0.1);
                  color: #0A9EE0;
                }
                .sc{
                  background:rgba($color: #EA1611, $alpha: 0.1);
                  color: #EA1611;
                }
              }
              .item {
                  display: flex;
                  align-items: center;
                    width: 33%;
                  .label {
                    text-align: center;
                    width: 30%;
                    font-size: 16px;
            
                    font-weight: 400;
                    color: #333333;
                  }
            
                  .value {
                    width: 70%;
                    display: flex;
                    gap:20px;
                  }
                 
                }
    }
  </style>